import {
  Companion_getInstanceus6z4605rk5c as Companion_getInstance,
  ProjectAttachmentv4m5lkl2nz8g as ProjectAttachment,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareProjectAttachmentFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ProjectAttachment_name_getInstance(), ProjectAttachment_fileType_getInstance(), ProjectAttachment_file_getInstance(), ProjectAttachment_preview_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ProjectAttachment_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ProjectAttachment_name$_get_name_$ref_h0gccl() {
  return (p0) => p0.k20();
}
function ProjectAttachment_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectAttachment_name$_get_serializer_$ref_1bgke() {
  return (p0) => p0.j2j();
}
function ProjectAttachment_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ProjectAttachment_name$_get_annotations_$ref_eytsyi() {
  return (p0) => p0.bz();
}
var ProjectAttachment_nameClass;
function ProjectAttachment_name() {
  if (ProjectAttachment_nameClass === VOID) {
    class $ {
      constructor() {
        ProjectAttachment_name_instance = this;
        var tmp = this;
        tmp.q79_1 = lazy(ProjectAttachment_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r79_1 = lazy(ProjectAttachment_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s79_1 = lazy(ProjectAttachment_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectAttachment_name$_get_name_$ref_h0gccl(), null);
        return tmp0.f2();
      }
      t79(receiver) {
        return receiver.u79_1;
      }
      m2j(receiver) {
        return this.t79(receiver instanceof ProjectAttachment() ? receiver : THROW_CCE());
      }
      y79(receiver, value) {
        return receiver.z79(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectAttachment() ? receiver : THROW_CCE();
        return this.y79(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectAttachment_name$_get_serializer_$ref_1bgke(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectAttachment_name$_get_annotations_$ref_eytsyi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectAttachment_name', VOID, VOID, [SerializableProperty()]);
    ProjectAttachment_nameClass = $;
  }
  return ProjectAttachment_nameClass;
}
var ProjectAttachment_name_instance;
function ProjectAttachment_name_getInstance() {
  if (ProjectAttachment_name_instance === VOID)
    new (ProjectAttachment_name())();
  return ProjectAttachment_name_instance;
}
function ProjectAttachment_fileType$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ProjectAttachment_fileType$_get_name_$ref_wjtx7e() {
  return (p0) => p0.k20();
}
function ProjectAttachment_fileType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectAttachment_fileType$_get_serializer_$ref_z7f2yb() {
  return (p0) => p0.j2j();
}
function ProjectAttachment_fileType$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ProjectAttachment_fileType$_get_annotations_$ref_9tlne9() {
  return (p0) => p0.bz();
}
var ProjectAttachment_fileTypeClass;
function ProjectAttachment_fileType() {
  if (ProjectAttachment_fileTypeClass === VOID) {
    class $ {
      constructor() {
        ProjectAttachment_fileType_instance = this;
        var tmp = this;
        tmp.a7a_1 = lazy(ProjectAttachment_fileType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b7a_1 = lazy(ProjectAttachment_fileType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c7a_1 = lazy(ProjectAttachment_fileType$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.a7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectAttachment_fileType$_get_name_$ref_wjtx7e(), null);
        return tmp0.f2();
      }
      t79(receiver) {
        return receiver.v79_1;
      }
      m2j(receiver) {
        return this.t79(receiver instanceof ProjectAttachment() ? receiver : THROW_CCE());
      }
      y79(receiver, value) {
        return receiver.z79(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectAttachment() ? receiver : THROW_CCE();
        return this.y79(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectAttachment_fileType$_get_serializer_$ref_z7f2yb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectAttachment_fileType$_get_annotations_$ref_9tlne9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectAttachment_fileType', VOID, VOID, [SerializableProperty()]);
    ProjectAttachment_fileTypeClass = $;
  }
  return ProjectAttachment_fileTypeClass;
}
var ProjectAttachment_fileType_instance;
function ProjectAttachment_fileType_getInstance() {
  if (ProjectAttachment_fileType_instance === VOID)
    new (ProjectAttachment_fileType())();
  return ProjectAttachment_fileType_instance;
}
function ProjectAttachment_file$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ProjectAttachment_file$_get_name_$ref_pk3udo() {
  return (p0) => p0.k20();
}
function ProjectAttachment_file$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectAttachment_file$_get_serializer_$ref_wbgm6l() {
  return (p0) => p0.j2j();
}
function ProjectAttachment_file$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ProjectAttachment_file$_get_annotations_$ref_8nyqi1() {
  return (p0) => p0.bz();
}
var ProjectAttachment_fileClass;
function ProjectAttachment_file() {
  if (ProjectAttachment_fileClass === VOID) {
    class $ {
      constructor() {
        ProjectAttachment_file_instance = this;
        var tmp = this;
        tmp.d7a_1 = lazy(ProjectAttachment_file$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e7a_1 = lazy(ProjectAttachment_file$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f7a_1 = lazy(ProjectAttachment_file$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.d7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectAttachment_file$_get_name_$ref_pk3udo(), null);
        return tmp0.f2();
      }
      g7a(receiver) {
        return receiver.w79_1;
      }
      m2j(receiver) {
        return new (ServerFile())(this.g7a(receiver instanceof ProjectAttachment() ? receiver : THROW_CCE()));
      }
      h7a(receiver, value) {
        return receiver.z79(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectAttachment() ? receiver : THROW_CCE();
        return this.h7a(tmp, value instanceof ServerFile() ? value.n2n_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectAttachment_file$_get_serializer_$ref_wbgm6l(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectAttachment_file$_get_annotations_$ref_8nyqi1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectAttachment_file', VOID, VOID, [SerializableProperty()]);
    ProjectAttachment_fileClass = $;
  }
  return ProjectAttachment_fileClass;
}
var ProjectAttachment_file_instance;
function ProjectAttachment_file_getInstance() {
  if (ProjectAttachment_file_instance === VOID)
    new (ProjectAttachment_file())();
  return ProjectAttachment_file_instance;
}
function ProjectAttachment_preview$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ProjectAttachment_preview$_get_name_$ref_xmawpa() {
  return (p0) => p0.k20();
}
function ProjectAttachment_preview$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectAttachment_preview$_get_serializer_$ref_f3mfdz() {
  return (p0) => p0.j2j();
}
function ProjectAttachment_preview$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ProjectAttachment_preview$_get_annotations_$ref_ptxunx() {
  return (p0) => p0.bz();
}
var ProjectAttachment_previewClass;
function ProjectAttachment_preview() {
  if (ProjectAttachment_previewClass === VOID) {
    class $ {
      constructor() {
        ProjectAttachment_preview_instance = this;
        var tmp = this;
        tmp.i7a_1 = lazy(ProjectAttachment_preview$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j7a_1 = lazy(ProjectAttachment_preview$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k7a_1 = lazy(ProjectAttachment_preview$annotations$delegate$lambda);
        this.l7a_1 = null;
        this.m7a_1 = 'null';
      }
      k20() {
        var tmp0 = this.i7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectAttachment_preview$_get_name_$ref_xmawpa(), null);
        return tmp0.f2();
      }
      n7a(receiver) {
        return receiver.x79_1;
      }
      m2j(receiver) {
        var tmp = this.n7a(receiver instanceof ProjectAttachment() ? receiver : THROW_CCE());
        return tmp == null ? null : new (ServerFile())(tmp);
      }
      o7a(receiver, value) {
        return receiver.z79(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectAttachment() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof ServerFile()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.n2n_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.o7a(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.j7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectAttachment_preview$_get_serializer_$ref_f3mfdz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectAttachment_preview$_get_annotations_$ref_ptxunx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectAttachment_preview', VOID, VOID, [SerializableProperty()]);
    ProjectAttachment_previewClass = $;
  }
  return ProjectAttachment_previewClass;
}
var ProjectAttachment_preview_instance;
function ProjectAttachment_preview_getInstance() {
  if (ProjectAttachment_preview_instance === VOID)
    new (ProjectAttachment_preview())();
  return ProjectAttachment_preview_instance;
}
//region block: exports
export {
  prepareProjectAttachmentFields as prepareProjectAttachmentFields1yfzud6ogszfz,
};
//endregion

//# sourceMappingURL=ProjectAttachmentFields.mjs.map
